export const sanitizeCultivarItem = ({ id, ...cultivarsItem }) => {
  const materialId = parseInt(cultivarsItem.materialsId)
  const area = Number(cultivarsItem.area)
  let data = {
    id,
    materialsId: materialId,
    area,
    cultivarsId: cultivarsItem.cultivarsId,
    cultivarsTypeId: cultivarsItem.cultivarsTypeId,
    cultivarsDemandTypeId: cultivarsItem.cultivarsDemandTypeId
  }

  if (isNaN(id)) {
    return data
  }

  return { id, ...data }
}
